var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"text-center h5 my-4"},_vm._l((_vm.steps),function(step,index){return _c('b-col',{key:+(index + 1)},[_c('router-link',{attrs:{"to":_vm.path + +(index + 1)}},[_vm._v(_vm._s(step))])],1)}),1),_c('b-progress',{attrs:{"value":_vm.progressValue,"max":_vm.progressMax}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }